import React from "react";

import {
	Button,
	Drawer,
	Space,
	Popconfirm,
	Checkbox,
} from "antd";
import { 
	QuestionCircleOutlined ,
	RightOutlined,
	LeftOutlined,
} from "@ant-design/icons";

import { InformationComponent } from "../InformationComponent";

import PropTypes from "prop-types";

export const FixErrorDrawer = ({
	hoveredItem,
	setHoveredItem,
	setSelected,
	errorsReports,
	onClose, 
	openEdit, 
	selected, 
	selectedOptions, 
	massiveCheckedList, 
	onChangeElementSelected,
	updateStatusError,
	loadingSubmit,
}) => {
	const chargeNext = () => {
		if(hoveredItem === null) return;
		
		const number = hoveredItem + 1;
		setHoveredItem(number % errorsReports.length);
		setSelected(errorsReports[number % errorsReports.length]);
	};

	const chargePrevious = () => {
		if(hoveredItem === null) return;

		const number = hoveredItem - 1;
		if(number < 0){
			setHoveredItem(errorsReports.length - 1);
			setSelected(errorsReports[errorsReports.length - 1]);
			return;
		}
		setHoveredItem(number);
		setSelected(errorsReports[number]);
	};
	
	return (
		<Drawer
			title="Corregir Error"
			placement="right"
			width={800}
			onClose={onClose}
			open={openEdit}
			extra={
				<Space>
					{selectedOptions.error_verified === false && <Checkbox 
						disabled={selected.error_verified}
						checked={massiveCheckedList.find((checked) => checked === selected.id) !== undefined}
						onChange={(e) => onChangeElementSelected(e, selected.id)} 
					>Marcar para envio masivo</Checkbox>}
					<Button
						type="primary"
						icon={<LeftOutlined />}
						size="large"
						onClick={chargePrevious}
					/>
					<Button
						type="primary"
						icon={<RightOutlined />}
						size="large"
						onClick={chargeNext}
					/>
					<Popconfirm
						title="Error corregido"
						description="¿Estas seguro que ya revisaste que los errores esten corregidos?"
						onConfirm={updateStatusError}
						icon={<QuestionCircleOutlined style={{ color: "red" }} />}
					>
						{(selectedOptions.error_verified !== false) && 
						<Button type="primary" disabled={selected.error_verified} loading={loadingSubmit}>			
							{(!selected.error_verified) ? "Marcar como corregido" : "Ya esta Corregido"}					
						</Button>
						}
						{(massiveCheckedList.length <= 1 && selectedOptions.error_verified === false) && 
						<Button type="primary" disabled={selected.error_verified} loading={loadingSubmit}>			
							{(!selected.error_verified) ? "Marcar como corregido" : "Ya esta Corregido"}					
						</Button>
						}
						{(selectedOptions.error_verified === false && massiveCheckedList.length > 1) && 
						<Button type="primary" disabled={selected.error_verified} loading={loadingSubmit}>			
							Realizar Corrección Masiva
						</Button>}							
					</Popconfirm>
				</Space>
			}
		>
			<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "15px" }}>
				{/* <InformationComponent title={"Numero Error: "} attribute={`Error #${hoveredItem}`} /> */}
				<InformationComponent title={"Nombre Procesos: "} attribute={selected.name_process} />
				<InformationComponent title={"Tipo de Error: "} attribute={selected.type} />
				<InformationComponent title={"Fecha detección: "} attribute={selected.date} />
				<InformationComponent title={"Estado: "} attribute={(selected.error_verified) ? "Ya Corregido" : "Sin Corregir"} />
				{selected.error_verified && (
					<>
						<InformationComponent title={"Verificado por: "} attribute={selected.verified_by}/>
						<InformationComponent title={"Fecha corrección: "} attribute={selected.date_of_verification}/>
					</>
				)}
			</div>
			
			<div>
				<pre style={{ 
					whiteSpace: "pre-wrap", 
					wordWrap: "break-word",
					backgroundColor: "#f5f5f5",
					padding: "10px",
					borderRadius: "4px"
				}}>
					{JSON.stringify(selected, null, 2)}
				</pre>
			</div>
		</Drawer>
	);
};

FixErrorDrawer.propTypes = {
	hoveredItem: PropTypes.number.isRequired,
	setHoveredItem: PropTypes.func.isRequired,
	setSelected: PropTypes.func.isRequired,
	errorsReports: PropTypes.array.isRequired,
	onClose: PropTypes.func.isRequired,
	openEdit: PropTypes.bool.isRequired, 
	selected: PropTypes.object.isRequired, 
	selectedOptions: PropTypes.object.isRequired, 
	massiveCheckedList: PropTypes.array.isRequired, 
	onChangeElementSelected: PropTypes.func.isRequired,
	updateStatusError: PropTypes.func.isRequired,
	loadingSubmit: PropTypes.bool.isRequired,
};
